export const environment = {
  env: 'development',
  production: false,
  APP_URL: 'https://olympus-dev.wendell.siemens.cloud',
  SHARED_APP_DOMAIN: 'https://afd-st-olympus-portal-dev-eastus2-002-gvh4fdf0fwfwftfm.a02.azurefd.net/shared/remoteEntry.js'
};
